<template>
    <!-- 入院咨询 -->
    <div>
        <div class="container">
            <div class="handle-box">
                <el-form :inline="true" ref="form" :model="query" label-width="100px">
                    <el-form-item label="老人姓名：">
                        <el-input v-model="query.name" clearable placeholder="请输入老人姓名" class="avatar-uploader"></el-input>
                    </el-form-item>
                    <el-form-item label="回访状态：">
                        <el-select v-model="query.status" clearable placeholder="请选择回访状态搜索" class="avatar-uploader">
                            <el-option label="0.待回访" value="0"></el-option>
                            <el-option label="1.已回访" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" class="ml20" @click="getData">查询</el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新建</el-button>
                </el-form>
            </div>
            <el-table :data="tableData" border class="table">
                <el-table-column prop="name" label="老人姓名" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="phone" label="联系电话"></el-table-column>
                <el-table-column prop="type" :formatter="formatType" label="咨询方式"></el-table-column>
                <el-table-column prop="street" label="所属街道"></el-table-column>
                <!-- <el-table-column prop="groupName" label="咨询机构"></el-table-column> -->
                <el-table-column prop="creator" label="咨询人姓名" width="100"></el-table-column>
                <el-table-column prop="address" label="咨询地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="咨询内容"></el-table-column>

                <el-table-column prop="dayStr" label="预约时间"  width="150"></el-table-column>

                <el-table-column prop="creator" label="是否回访" width="90">
                    <template slot-scope="scope">{{scope.row.status==1?'已回访':'待回访'}}</template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-phone" @click="returnVisit(scope.row)">回访</el-button>
                        <!-- @click="handleEdit(scope.$index, scope.row)">回访</el-button> -->
                        <el-button type="text" icon="el-icon-delete" class="red"
                            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.pageNum"
                    :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog :title="isAdd ? '新建咨询' : '编辑咨询'" :visible.sync="editVisible" width="1200px"
            :close-on-click-modal="false">
            <el-form ref="form" :model="form" :inline="true" label-width="90px">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="老人姓名:">
                            <el-input v-model="form.name" class="common-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系电话:">
                            <el-input v-model="form.phone" class="common-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="咨询方式:">
                            <el-select v-model="form.type" class="common-input">
                                <el-option key="0" label="入院咨询" value="0"></el-option>
                                <el-option key="1" label="预约参观" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="8">
                        <el-form-item label="所属街道:">
                            <el-input v-model="form.street" class="common-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="咨询机构:">
                            <el-input v-model="form.groupName" class="common-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="咨询地址:">
                            <el-input v-model="form.address" class="common-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="咨询内容:">
                            <el-input v-model="form.content" class="common-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="咨询人姓名:">
                            <el-input v-model="form.creator" class="common-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="预约时间:">
                            <el-date-picker
                            v-model="form.dayStr"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择预约时间">
                            </el-date-picker>

                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <el-form-item label="备注">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
                            v-model="form.remark" class="big-input"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'AdmissionConsultText',
    data() {
        return {
            query: {
                type: "",
                street: "",
                name:"",
                status: "",
                community: "",
                groupId: Number(sessionStorage.getItem("groupId")),
            },
            tableData: [],
            editVisible: false,
            psdVisible: false,
            isAdd: true,
            pageTotal: 0,
            psdform: {},
            form: {},

        };
    },
    created() {
        this.getData();
    },
    methods: {
        formatStatus(row, index) {
            if (row.status == 0) {
                return '待审核';
            } if (row.status == 2) {
                return '审核通过';
            } if (row.status == 4) {
                return '审核不通过';
            } else {
                return null;
            }
        },
        formatType(row, index) {
            if (row.type == 0) {
                return '入院咨询';
            } if (row.type == 1) {
                return '预约参观';
            } else {
                return null;
            }
        },
        getData() {
            this.$postJson('uac/groupReservation/selectAll', this.query).then(res => {
                console.log(res);
                if (res.result && res.result.list) {
                    this.tableData = res.result.list;
                    this.pageTotal = Number(res.result.total)
                } else {
                    // 处理搜索失败的情况，可以显示错误信息或清空表格数据等
                    this.tableData = [];
                    this.pageTotal = 0;
                }
            })
        },


        // 触发添加按钮
        handleAdd() {
            this.form = {
                name: '',
                phone: '',
                type: '',
                status: '',
                community: '',
                street: '',
                groupId: sessionStorage.getItem("groupId"),
                groupName: '',
                address: '',
                content: '',
                creator: '',
                dayStr: ''
            };
            this.editVisible = true;
            this.isAdd = true;
        },
      handleDelete(index, row) {
        this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                this.$postJson("uac/groupReservation/delete/"+row.id, {}).then(res=>{
                    this.$message({
                        message: res.message,
                        type: "success"
                    });
                    this.getData();
                })
            })
      },
        //回访操作
        returnVisit(row) {
            console.log(row);
            this.$confirm('是否已回访？', '请确认已回访', {
                confirmButtonText: '是',
                cancelButtonText: '否',
            })
                .then(() => {
                    // 用户选择“是”，发送已回访状态
                    this.$postJson(`uac/groupReservation/confirm/${row.id}`)
                        .then(response => {
                            console.log('已回访成功', response);
                        })
                        .catch(error => {
                            console.error('已回访失败', error);
                        });
                })
                .catch(() => {
                   
                });
        },
        // 保存编辑
        saveEdit() {
            let params =  this.form;
            console.log(params)
            this.$postJson('uac/groupReservation/save', params).then(res=>{
                if(res.code != 200){
                    this.$message({
                        message: "登记失败",
                        type: "error",
                    });
                    return;
                }
                this.$message({
                    message: "登记成功",
                });
                this.editVisible = false;
                this.getData();
            })


        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
            this.getData();
        },
    }
};

</script>

<style scoped>
.handle-box {
    margin-bottom: 5px;
}

.handle-input {
    width: 200px;
}

.common-select {
    width: 285px;
}

.common-input {
    width: 285px;
}

.big-input {
    width: 675px;
}

.sex-select {
    width: 90px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.ml20 {
    margin-left: 20px;
}

.avatar-uploader {
    width: 180px;
}

.big_iv>>>.el-upload {
    width: 180px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.el-upload--text {
    width: 180px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.red{
    color: red;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>